
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Routes, Route, Link, useLocation, } from "react-router-dom";

import { Outlet } from 'react-router-dom';

import Navbar from "./components/navbar.jsx";
import HomePage from "./components/home.jsx";
import Training from "./components/training.jsx";
import Leave from "./components/leave.jsx";
import Attendance from "./components/attendence.jsx";
import Performance from "./components/performance.jsx";
import JobPosting from "./components/jobposting.jsx";
import Tracking from "./components/tracking.jsx";
import Addpersonal from "./components/addpersonal.jsx";
import Addfinancial from "./components/addfinancial.jsx";
import Viewpersonal from "./components/viewpersonal.jsx";
import Viewfinancial from "./components/viewfinancial.jsx";
import Interview from "./components/Interview.jsx";
import Bonafied from "./components/bonafied.jsx";
import AdvanceSalary from "./components/advancesalary.jsx";
import Register from "./components/Register.jsx";
import Login from "./components/Login.jsx";
import TermsOfUse from "./components/TermsOfUse.jsx";
import PrivacyPolicy from "./components/PrivacyPolicy.jsx";
import OfferForm from "./components/offer.jsx";
import OnboardingForm from "./components/onboarding.jsx";
import ProtectedRoute from "./components/protected.jsx";
import ManagerApproval from "./components/managerapproval.jsx";

import Jobview from "./components/jobview.jsx";
import { AppBar, Toolbar, Button, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";

import { Feedback, Reviews } from "@mui/icons-material";
import ImprovementManagement from "./components/improvement.jsx";
import FeedbackPage from "./components/feedback.jsx";
import PerformanceReviewsTab from "./components/review.jsx";
import SuccessionPlan from "./components/succession.jsx";
import TrainingList from "./components/viewtraining.jsx";
import UploadSal from "./components/uploadsalary.jsx";
import EmployeeUploadDoc from "./components/employeedocument.jsx";
import DocumentStatus from "./components/viewdocument.jsx";
import PayrollTax from "./components/payrolltax.jsx";
import GeneratePayslip from "./components/generatepayslip.jsx";
import Payslip from "./components/payslip.jsx";
import MonthlyTax from "./components/monthlytax.jsx"
import YearlyTax from "./components/yeartax.jsx";
import TotalTax from "./components/totaltax.jsx"
import BonafideRequestList from "./components/viewbonafied.jsx";
import AdvanceSalaryRequestList from "./components/viewsalaryreq.jsx";
import EmployeeDashboard from "./components/viewperformance.jsx";
import EmployeeReviewsPage from "./components/viewreview.jsx";
import ViewFeedbackPage from "./components/viewfeedback.jsx";
import ViewImprovementPlans from "./components/viewpip.jsx";
import EmployeeSuccessionPlan from "./components/viewsuccession.jsx"
import SharedNavbar from "./components/performancenavbar.jsx";
import InterviewStatusUpdate from "./components/interviewstatus.jsx"
import StatusPage from "./components/status.jsx";
import MonthlyTaxSpecific from "./components/MonthlyTaxSpecific.jsx"
import CompanyDetails from "./components/CompanyDetails.jsx"
import FloatingSupportWidget from "./components/Support/FloatingSupportWidget.jsx";
import UploadDocument from "./components/upload.jsx";
import { AuthProvider } from './components/onboardinglist.jsx';
import OnboardingList from "./components/onboardinglist.jsx"
import EmployeeCertificateView from "./components/viewcertificate.jsx"
import AddRoles from "./components/addroles.jsx";
import ViewRoles from "./components/viewroles.jsx";
import EmployeeTrainingView from "./components/emptrainingview.jsx"
import HRTrainingDetail from "./components/trainingdetails.jsx"
import TrainingVideoManagement from "./components/trainingvideo.jsx";
import SearchEmployee from "./components/searchemployee.jsx"
import ProjectedTax from "./components/projectedtax.jsx"
import FormPartA from "./components/FormPartA.jsx";
import FormPartB from "./components/FormPartB.jsx";
import Form16 from "./components/form16.jsx";
import ManualAttendance from "./components/ManualAttendance.jsx";
import HRTestManagement from "./components/addtest.jsx";
import EmployeeProfile from "./components/employeeprofile.jsx";
import Sidebar from "./components/Sidebar.jsx";
import Form12BB from "./components/Form12BB.jsx";
import ViewCtc from "./components/ViewCtc.jsx";
import ViewForm12BB from "./components/View12BB.jsx"
import Claims from "./components/Claims.jsx";
import ViewClaims from "./components/ViewClaims.jsx";
import PersonalDetails from "./components/PersonalDetails.jsx";
import Referral from './components/Referral.jsx';
import PublicApply from './components/PublicApply.jsx';
import OfferApproval from './components/OfferApproval.jsx';
import SendOffer from './components/SendOffer.jsx'
// import HraExemptionCalculator from './components/HraExemption.jsx';
import InvestmentDeclarationForm from './components/InvestmentDec.jsx';
import PropertyLossForm from './components/LossProperty.jsx';
import InvestmentProofSubmission from './components/InvestmentProof.jsx';
import TaxFormWithTabs from './components/Tabs.jsx';
import ProofApproval from './components/Approval.jsx';
import AllowanceClaimSystem from './components/AllowanceClaim.jsx';
import AllowanceClaimApproval from './components/AllowanceApproval.jsx';
import HRPropertyLossDashboard from './components/ViewLossProperty.jsx';
import CreateProject from './components/createproject.jsx';
import ActiveProjects from './components/activeprojects.jsx';
import TaskManagement from './components/createtask.jsx';
import MyTasksPage from './components/mytask.jsx';
import Dashboard from './components/dashboard.jsx';
import AssignTeam from './components/AssignTeam.jsx';
import ManageTeam from './components/ManageTeam.jsx';
import TeamManagementApp from './components/CreateTeam.jsx';
import ViewContractEmployees from './components/ContractEmpList.jsx';
import ContractorDetailsForm from './components/Contractor.jsx';
import CreateIssuePage from './components/createissues.jsx';
import AllTasksPage from './components/alltask.jsx';
import EmployeeForm from './components/ContractEmployee.jsx';
import AuditLogs from './components/AuditLogs.jsx';
import ProjectCalendar from './components/Calender.jsx';
import ProjectDetailsDialog from './components/viewproject.jsx';

import ActiveSprints from './components/activesprint.jsx';
import CreateSprint from './components/createsprints.jsx';
import Backlogpage from "./components/backlogs.jsx"
import RoadmapPage from './components/roadmap.jsx';
import BasicBoard from './components/createboard.jsx';
import AllProjects from './components/allprojects.jsx';
import ProjectMigrationPage from './components/ProjectMigrationPage.jsx';
import ProjectManagementSystem from './components/projectupdates.jsx';
import CompletedSprintBoard from './components/CompletedSprint.jsx';
import CpoPpmDashboard from './components/CpoPpmDashboard.jsx';
import ResourcePlanningDashboard from './components/ResourcePlanningDashboard.jsx';
import NpiIntakeDashboard from './components/NpiIntakeDashboard.jsx';
import CpoMultiProjectDashboard from './components/CpoMultiProjectDashboard.jsx';

import ProjectDashboard from './components/projectdashboard.jsx';

import ViewStatus from './components/performancestatus.jsx';
import DashboardHome from './components/individualdashboard.jsx';
import RecruitmentReportsDashboard from './components/recruitmentdashboard.jsx';
import EmployeeManagementReport from './components/employeereport.jsx';
import Report from './components/leavereport.jsx';
import AttendanceReportDashboard from './components/attendencereport.jsx';
import PerformanceReportDashboard from './components/performancereport.jsx';

import ReportDashboard from './components/PayrollReports.jsx';
import PMReportDashboard from './components/PMReport.jsx';
import LeavePolicyManagement from './components/LeavePolicy.jsx';
import EmployeePaymentsTable from './components/EmployeePayment.jsx';
import CandidatePersonalDetails from './components/EmployeeUpdatePersonalDetails.jsx';
import CandidateFinancialDetails from './components/EmployeeUpdateFinancialDetails.jsx';
import HRUpdateRoles from './components/HRUpdateRoles.jsx';
import ChangeRequirementsPage from './components/ChangeRequirement.jsx';
import ComplianceDashboard from './components/EmployeeCompliance.jsx';

import GapAnalysis from './components/gapanalysis.jsx';
import SkillMatrixPage from './components/skillMatrix.jsx';
import ResourceCapacity from './components/ResourceCapacity.jsx';

import UploadFrd from './components/UploadFrd.jsx';

import PredictionDashboard from './components/LeavePrediction.jsx';
import EmployeeFeedbackForm from './components/EmployeeFeedback.jsx';
import HRFeedbackView from './components/HRViewFeedback.jsx';
import MonthlyAttritionDashboard from './components/leaveAttrition.jsx';
import QuotationDashboard from './components/QuotationDashboard.jsx';
import LiveQuotationFromTemplate from './components/useTemplate.jsx';
import QuotationPreview from './components/TemplatePreview.jsx';
import HolidayManagement from './components/holidayMgmt.jsx';
import EmployeeHolidayView from './components/viewholiday.jsx';
import HREmployeeFormWithTabs from './components/HRfromTabs.jsx';
import CompanyDetailsView from './components/updateCompanyDetails.jsx';
import AppraisalCycleManager from './components/AppraisalCycleManager.jsx';
import EmployeeSelfAppraisal from './components/EmployeeSelfAppraisal.jsx';
import ManagerReviewDashboard from './components/ManagerReview.jsx';
import TeamContributionOverview from './components/TeamContributionOverview.jsx';
import EnhancedActiveProjectsEmployee from './components/activeprojectEmployee.jsx';
import AllProjectsEmployee from './components/AllProjectEmployee.jsx';
import ProfessionalProjectDashboardEmp from './components/ProjectDashboardEmployee.jsx';
import ExperienceRequest from './components/ExperienceRequestForm.jsx';
import ExperienceRequestList from './components/ExperienceRequestList.jsx';
import AdminEmployeeFormWithTabs from './components/AdminEmployeeFormWithTabs.jsx';
import GratuityTab from './components/GratuityTab.jsx';
import SalaryRevisionTab from './components/SalaryRevisionTab.jsx';
import ExpenditureReport from './components/MaleFemaleFundReport.jsx';
import PayrollRegister from './components/PayrollRegister.jsx';
import TimesheetApproval from './components/TimesheetApproval.jsx';
import TimesheetForm from './components/TimeStamp.jsx';
import FinanceGratuityTab from './components/FinanceGratuityTab.jsx';
import FormTPage from './components/FormTPage.jsx';
import AdminFormTApproval from './components/FormTApproval.jsx';
import ManageCostCenters from './components/ManageCostCenters.jsx';
import HRCostCenters from './components/HRCostCenters.jsx';
import CostCenterDashboard from './components/CostCenterDashboard.jsx';
import PMCostCenterDashboard from './components/PMCostCenterDashboard.jsx';
import MinimumWageCompliance from './components/MinimumWageCompliance.jsx';
import DiscoveryResults from './components/DiscoveryResults.jsx';
import EmployeeAttendanceCalendar from './components/EmployeeAttendanceCalendar.jsx';
import ManagerApprovalAttendance from './components/ManagerApprovalAttendance.jsx';
import EmployeeAttendanceRequest from './components/EmployeeAttendanceRequest.jsx';
import ManagerTeamAttendance from './components/ManagerTeamAttendance.jsx';
import AssetManagement from './components/AssetManagement.jsx';
import MyAssets from './components/MyAssets.jsx';
import TeamOnLeave from './components/TeamOnLeave.jsx';
import Engage from './components/Engage.jsx';
import Offboarding from './components/Offboarding.jsx';
import SupportTicketPage from './components/SupportTicket.jsx';
import ManagerSupportTickets from './components/ManagerSupportTickets.jsx';
import HRSupportTickets from './components/HRSupportTickets.jsx';
import FinanceSupportTickets from './components/FinanceSupportTickets.jsx';
import ProFormaInvoice from './components/ProformaInvoice.jsx';
import ProFormaHistory from './components/ProformaHistory.jsx';
import EmployeeHierarchyTree from './components/EmployeeHierarchyTree.jsx';
import PayrollSettings from './components/CompanyPayrollSettings.jsx';
import SalaryExport from './components/SalaryExport.jsx';
import FinanceSalaryApproval from './components/FinanceSalaryApproval.jsx';
import FinanceManagerApproval from './components/FinanceManagerApproval.jsx';
import HRPayrollProcessing from './components/HRPayrollProcessing.jsx';
import FinancePayroll from './components/FinancePayroll.jsx';
import SSOCallback from './components/SSOCallback.jsx';
import SSOSettings from './components/SSOSettings.jsx';
import SkillExpertise from './components/SkillExpertise.jsx';
import TrialBanner from './components/Subscription/TrialBanner.jsx';
import GracePeriodBanner from './components/Subscription/GracePeriodBanner.jsx';
import UpgradePlanModal from './components/Subscription/UpgradePlanModal.jsx';
const theme = createTheme({
  palette: {
    primary: { main: "#1976d2" },
    secondary: { main: "#f50057" },
  },
});


const App = () => {
  const [sidebaropen, setSidebarOpen] = useState(window.innerWidth > 900);
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const [lockedFeaturePrompt, setLockedFeaturePrompt] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const location = useLocation();
  const isPublicApply = location.pathname.startsWith('/public/apply');

  useEffect(() => {
    const handleOpenUpgrade = (e) => {
      const userRole = localStorage.getItem("role")?.toLowerCase();
      if (userRole !== "admin") {
        const msg = e?.detail?.message || "Storage limit reached for your company's subscription. Please contact your organization administrator to upgrade the plan.";
        alert(msg);
        return;
      }

      if (e?.detail?.feature) {
        setLockedFeaturePrompt(e.detail.feature);
      } else {
        setLockedFeaturePrompt(null);
      }
      setUpgradeModalOpen(true);
    };

    window.addEventListener("openUpgradeModal", handleOpenUpgrade);

    // Global interceptor: automatically catch 403 STORAGE_LIMIT_EXCEEDED across any upload form in the app
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const errData = error.response?.data;
        const errMsg = (errData?.message || error.message || "").toLowerCase();
        const isStorageLimit =
          (error.response?.status === 403 || error.response?.status === 500) &&
          (errData?.code === "STORAGE_LIMIT_EXCEEDED" ||
           errData?.reason === "STORAGE_LIMIT_EXCEEDED" ||
           errMsg.includes("storage limit") ||
           errMsg.includes("subscription storage"));

        if (isStorageLimit) {
          window.dispatchEvent(
            new CustomEvent("openUpgradeModal", {
              detail: {
                feature: "STORAGE_LIMIT_EXCEEDED",
                message: errData?.message || "Storage limit exceeded. Please upgrade your subscription plan."
              }
            })
          );
        }
        return Promise.reject(error);
      }
    );

    return () => {
      window.removeEventListener("openUpgradeModal", handleOpenUpgrade);
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  const [logoutPopupMsg, setLogoutPopupMsg] = useState(null);

  useEffect(() => {
    const role = localStorage.getItem('role');
    let companyId = null;
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const userObj = JSON.parse(userStr);
        companyId = userObj.company_id;
      }
    } catch (err) {}

    let ws;
    if (role && companyId) {
      // Connect to system stream using standard URL derivation
      const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5001";
      const wsHost = new URL(apiUrl).host;
      const wsUrl = `${wsProtocol}//${wsHost}/system-stream`;
      
      ws = new WebSocket(wsUrl);
      
      ws.onopen = () => {
        ws.send(JSON.stringify({ type: 'authenticate', tenantId: parseInt(companyId) }));
      };
      
      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'FORCE_LOGOUT') {
            setLogoutPopupMsg(data.message || 'Your organization account has been deactivated.');
          }
        } catch (err) {}
      };
    }
    return () => {
      if (ws) ws.close();
    };
  }, [location.pathname]); // Re-evaluate when location changes (like on successful login)

  const handleForceLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setLogoutPopupMsg(null);
    window.location.href = '/login';
  };

  if (isPublicApply) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{
          minHeight: '100vh',
          bgcolor: '#f8fafc',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Routes>
            <Route path="/public/apply/:companyId/:jobId" element={<PublicApply />} />
          </Routes>
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Navbar
          sidebaropen={sidebaropen}
          setSidebarOpen={setSidebarOpen}
          onUpgradeClick={() => {
            setLockedFeaturePrompt(null);
            setUpgradeModalOpen(true);
          }}
          currentSubscription={subscription}
          onSubscriptionUpdate={(sub) => setSubscription(sub)}
        />
        <UpgradePlanModal
          open={upgradeModalOpen}
          onClose={() => {
            setUpgradeModalOpen(false);
            setLockedFeaturePrompt(null);
          }}
          lockedFeature={lockedFeaturePrompt}
          onUpgradeSuccess={(newSub) => setSubscription(newSub)}
        />
        <Dialog open={!!logoutPopupMsg} disableEscapeKeyDown>
          <DialogTitle>Account Deactivated</DialogTitle>
          <DialogContent>
            <DialogContentText>{logoutPopupMsg}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleForceLogout} color="primary" variant="contained">
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Box sx={{
          display: 'flex',
          flexGrow: 1,
          overflow: 'hidden'
        }}>
          <Sidebar 
            open={sidebaropen} 
            setOpen={setSidebarOpen} 
            currentSubscription={subscription} 
          />

          <Box component="main" sx={{
            flexGrow: 1,
            p: { xs: 2, md: 5 },
            overflowY: 'auto',
            overflowX: 'hidden',
            transition: "margin-left 0.3s ease, width 0.3s ease",
            width: { xs: '100%', md: sidebaropen ? "calc(100% - 300px)" : "calc(100% - 72px)" },
          }}>
            <GracePeriodBanner
              subscription={subscription}
              onUpgradeClick={() => {
                setLockedFeaturePrompt("GRACE_RENEWAL");
                setUpgradeModalOpen(true);
              }}
            />
            <Outlet />



            <Routes>
              <Route path="/" element={<HomePage />} />    
              <Route path='/home' element={<DashboardHome />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/terms" element={<TermsOfUse />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path='/sso/callback' element ={<SSOCallback/>}/>
              <Route path="/public/apply/:companyId/:jobId" element={<PublicApply />} />

            


              <Route element={<ProtectedRoute allowedRoles={["admin", "hr", "hr-manager", "project-manager"]} />}>
                <Route path="/addpersonal" element={<Addpersonal />} />
                <Route path="/addfinancial" element={<Addfinancial />} />
                <Route path="/addrole" element={<AddRoles />} />
 <Route path="/admin/audit-logs" element={<AuditLogs />} />
              </Route>
<Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
<Route path='/settings/sso' element={<SSOSettings/>}/>
                <Route path="/companydetails" element={<CompanyDetails />} />
<Route path='/company-payroll-settings' element={<PayrollSettings/>}/>
                <Route path='/addemppersonal' element={<AdminEmployeeFormWithTabs />} />
                <Route path="/manage-cost-centers" element={<ManageCostCenters />} />

              </Route>

              <Route element={<ProtectedRoute allowedRoles={["admin", "finance", "finance_manager"]} />}>
              <Route path='/update-company-details' element={<CompanyDetailsView/>}/>

              </Route>
<Route element={<ProtectedRoute allowedRoles={["project-manager","employee"]} />}>
              <Route path='/holiday' element={<EmployeeHolidayView />} />
              <Route path='/project-emp' element={<AllProjectsEmployee />} />
                <Route path="/active-projects-employee" element={<EnhancedActiveProjectsEmployee/>} />

</Route>
<Route element={<ProtectedRoute allowedRoles={["employee","project-manager", "product-manager", "product-owner", "cpo","principal-project-manager"]} />}>
              <Route path="/project/:projectId/skill-matrix" element={<SkillMatrixPage />} />

</Route>
<Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "employee"]} />}>
                            <Route path='/offboarding' element={<Offboarding />} />

                            </Route>
                            <Route element={<ProtectedRoute allowedRoles={["admin", "hr", "hr-manager", "hiring-manager", "employee","finance","project-manager","finance_manager", "product-manager", "product-owner","principal-project-manager", "cpo"]} />}>

                                <Route path='/engage' element={<Engage />} />
                                <Route path='/engage/milestones' element={<Engage activeTab="milestones" />} />
                             
                                <Route path='/engage/feeds' element={<Engage activeTab="feed" />} />

                            </Route>
                            <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager"]} />}>
                                <Route path="/assets" element={<AssetManagement />} />
                            </Route>
                            
                            <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "finance", "finance_manager", "admin"]} />}>
                                <Route path="/salary-export" element={<SalaryExport/>}/>
                                
                                <Route path="/hr-cost-centers" element={<HRCostCenters />} />
                                <Route path="/manage-cost-centers" element={<ManageCostCenters />} />
                            </Route>
    <Route element={<ProtectedRoute allowedRoles={["finance_manager"]} />}>
     <Route path="/cost-center-dashboard" element={<CostCenterDashboard />} /></Route>
                        

                            {/* My Assets: Employees and Managers view their own assigned assets */}
                            <Route element={<ProtectedRoute allowedRoles={["employee", "project-manager"]} />}>
                                <Route path="/my-assets" element={<MyAssets />} />
                            </Route>

              <Route element={<ProtectedRoute allowedRoles={["project-manager"]} />}>
              <Route path="/team-on-leave" element={<TeamOnLeave />} />
              <Route path="/manager/team-attendance" element={<ManagerTeamAttendance />} />

              <Route path='/manager-regularization-Approval' element={<ManagerApprovalAttendance />} />
              <Route path='/time-sheet-approval' element={<TimesheetApproval/>}/>

                            <Route path='/appraisal-cycle-manager' element={<ManagerReviewDashboard/>}/>
                            <Route path='/manager/team-contributions' element={<TeamContributionOverview/>}/>
                                  
                <Route path="/manager" element={<ManagerApproval />} />
                <Route path="/performancestatus" element={<ViewStatus />} />
                <Route path="/review" element={<PerformanceReviewsTab />} />
                <Route path="/feedback" element={<FeedbackPage />} />
                <Route path="/improve" element={<ImprovementManagement />} />
                <Route path="/succession" element={<SuccessionPlan />} />
                {/* <Route path="/active-projects" element={<ActiveProjects />} /> */}
                {/* <Route path='/pro' element={<AllProjects />} /> */}
                <Route path='/createtask' element={<TaskManagement />} />
                <Route path='/tasks' element={<AllTasksPage />} />
               
              </Route>
                            <Route element={<ProtectedRoute allowedRoles={["project-manager"]} />}>
                            <Route path="/manager/support-tickets" element={<ManagerSupportTickets />} />

                            </Route>
                                                <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager"]} />}>
                            <Route path="/hr/support-tickets" element={<HRSupportTickets />} />
                            <Route path='/hr-payroll-processing' element={<HRPayrollProcessing/>}/>
                            
                            </Route>
                                                <Route element={<ProtectedRoute allowedRoles={["finance", "finance_manager"]} />}>
                                                <Route path="/salary-disbrusement" element={<FinanceSalaryApproval/>}/>
                                                <Route path="/salary-authorization-manager" element={<FinanceManagerApproval/>}/>
                                                 <Route path="/proforma-invoice" element={<ProFormaInvoice />} />
                                                 <Route path="/proforma-history" element={<ProFormaHistory />} />
                            <Route path="/finance/support-tickets" element={<FinanceSupportTickets />} />

                            </Route>
                                                                           <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
                            <Route path="/admin/support-tickets" element={<ManagerSupportTickets />} />
                           
                            </Route>
                                                                           <Route element={<ProtectedRoute allowedRoles={["finance"]} />}>
                                            <Route path="/finance/payroll-approval" element={<FinancePayroll />} />

                            </Route>

              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "project-manager", "employee"]} />}>
                <Route path="/attendance" element={<Attendance />} />

              </Route>
              <Route element={<ProtectedRoute allowedRoles={["employee"]} />}>
              <Route path="/skills-expertise" element={<SkillExpertise/>}/>
              <Route path="/support-center" element={<SupportTicketPage />}/>
              <Route path="/attendance-regularization" element={<EmployeeAttendanceRequest />} />
                <Route path="/manual-entry" element={<ManualAttendance />} />
                <Route path="/gratuity-overview" element={<GratuityTab />} />
              </Route>

              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "project-manager"]} />}>
                <Route path="/attendance" element={<Attendance />} />
                <Route path='/leaveprediction' element={<PredictionDashboard/>}/>
              </Route>
              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "project-manager", "cpo"]} />}>
                <Route path='/attendencereport' element={<AttendanceReportDashboard />} />
              </Route>
              <Route element={<ProtectedRoute allowedRoles={["employee", "project-manager"]} />}>
                <Route path="/performance" element={<Performance />} />
                <Route path="/attendance" element={<Attendance />} />
              </Route>

              <Route element={<ProtectedRoute allowedRoles={["employee"]} />}>
                              <Route path='/experience-letter' element={<ExperienceRequest/>}/>

              <Route path='/holiday' element={<EmployeeHolidayView />} />
                <Route path='/mytasks' element={<MyTasksPage />} />
<Route path='/empfeedback' element={<EmployeeFeedbackForm />} />
                <Route path="/bonafied" element={<Bonafied />} />
                <Route path="/advancesalary" element={<AdvanceSalary />} />
                <Route path="/leave" element={<Leave />} />
                <Route path="/view" element={<EmployeeDashboard />} />

                <Route path="/viewreview" element={<EmployeeReviewsPage />} />
                <Route path="/viewfeedback" element={<ViewFeedbackPage />} />
                <Route path="/viewpip" element={<ViewImprovementPlans />} />
                <Route path="/viewsuccession" element={<EmployeeSuccessionPlan />} />
                <Route path="/navbar" element={<SharedNavbar />} />
                <Route path="/attendance" element={<Attendance />} />
                <Route path="/updatetraining" element={<EmployeeTrainingView />} />
                <Route path="/employee" element={<EmployeeProfile />} />

              </Route>
              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "project-manager", "employee", "hiring-manager"]} />}>
                <Route path="/jobview" element={<Jobview />} />
              </Route>
              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "project-manager", "employee"]} />}>
                <Route path="/refer" element={<Referral />} />
              </Route>
              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "project-manager", "employee", "cpo"]} />}>
                <Route path='/leavereport' element={<Report />} />
              </Route>


              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "project-manager", "cpo"]} />}>
                <Route path='/recreport' element={<RecruitmentReportsDashboard />} />
                <Route path='/empreport' element={<EmployeeManagementReport />} />
              </Route>
              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "project-manager"]} />}>
                <Route path="/viewpersonal" element={<Viewpersonal />} />

                <Route path="/viewfinancial" element={<Viewfinancial />} />
                <Route path="/contract" element={<ContractorDetailsForm />} />
                <Route path="/contractemp" element={<EmployeeForm />} />

                <Route path="/viewrole" element={<ViewRoles />} />
                <Route path='/contractlist' element={<ViewContractEmployees />} />
                <Route path="/training" element={<Training />} />
                <Route path="/trainings" element={<TrainingList />} />
                <Route path="/training/add" element={<Training />} />
                <Route path="/video" element={<TrainingVideoManagement />} />

              </Route>
              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager"]} />}>
              <Route path="/discovery-results" element={<DiscoveryResults/>} />

                            <Route path='/appraisal-cycle-hr' element={<AppraisalCycleManager/>}/>
                              <Route path='/experience-letter-request' element={<ExperienceRequestList/>}/>

              <Route path="/holidaydetails" element={<HolidayManagement />} />
                <Route path="/sendoffer" element={<SendOffer />} />
                <Route path="/bonafiedlist" element={<BonafideRequestList />} />
                <Route path="/salaryrequest" element={<AdvanceSalaryRequestList />} />
                {/* <Route path="/search" element={<SearchEmployee />} /> */}
                <Route path="/search" element={<EmployeeHierarchyTree />} />
                <Route path="/hr-update-role" element={<HRUpdateRoles/>}/>
                <Route path='/all-feedback' element={<HRFeedbackView />} />
                <Route path='/attrition' element={<MonthlyAttritionDashboard/>}/>
              </Route>


              <Route element={<ProtectedRoute allowedRoles={["finance", "finance_manager"]} />}>
<Route path='/min-wage' element={<MinimumWageCompliance />} />
              <Route path='/form-t-approval' element={<AdminFormTApproval />} />
              <Route path='/gratuity-overview-report' element={<FinanceGratuityTab />} />
              <Route path='/payroll-register' element={<PayrollRegister />} />
<Route path='/expenditure-report' element={<ExpenditureReport />} />
              <Route path='/salary-revision' element={<SalaryRevisionTab/>}/>
              <Route path='/compliance' element={<ComplianceDashboard />} />
              <Route path="/upload-salary" element={<UploadSal />} />
                <Route path="/view-document" element={<DocumentStatus />} />
                <Route path="/proofapproval" element={<ProofApproval />} />
                <Route path="/payroll-calculation" element={<PayrollTax />} />
                <Route path="/generate-payslip" element={<GeneratePayslip />} />
                <Route path="/monthly-tax-all" element={<MonthlyTax />} />
                <Route path="/yearly-tax-all" element={<TotalTax />} />
                <Route path="/yearly-tax-specific" element={<YearlyTax />} />
                <Route path="/monthly-tax-specific" element={<MonthlyTaxSpecific />} />

                <Route path="/form16-partA" element={<FormPartA />} />
                <Route path="/form16-partB" element={<FormPartB />} />
                <Route path="/viewform12bb" element={<ViewForm12BB />} />
                <Route path="/allowanceproofapproval" element={<AllowanceClaimApproval />} />
                <Route path="/view-lossproperty" element={<HRPropertyLossDashboard />} />
                <Route path='/payroll-report' element={<ReportDashboard />} />
                <Route path="/employee-payment" element={<EmployeePaymentsTable />} />
              </Route>

              <Route element={<ProtectedRoute allowedRoles={["employee", "hr", "hr-manager"]} />}>
              <Route path ='/form-t' element={<FormTPage/>}/>
               </Route>
              <Route element={<ProtectedRoute allowedRoles={["employee"]} />}>
              <Route path='/Attendance-view' element={<EmployeeAttendanceCalendar/>} />
              <Route path='/timesheet' element={<TimesheetForm />} />
                            <Route path='/self-appraisal-cycle' element={<EmployeeSelfAppraisal/>}/>

              <Route path="/candidate-personal" element={<CandidatePersonalDetails/>}/>
          <Route path="/candidate-financial" element={<CandidateFinancialDetails/>}/>
                <Route path="/attendance" element={<Attendance />} />

                <Route path="/submit-document" element={<EmployeeUploadDoc />} />
                <Route path="/view-payslip" element={<Payslip />} />
                <Route path="/upload" element={<UploadDocument />} />
                <Route path="/Onboarding List" element={<OnboardingList />} />
                <Route path="/certificate" element={<EmployeeCertificateView />} />
                <Route path="/projected-tax" element={<ProjectedTax />} />
                <Route path="/personal" element={<PersonalDetails />} />
                <Route path="/form16" element={<Form16 />} />
                <Route path="/view-ctc" element={<ViewCtc />} />
                <Route path="/form12bb" element={<Form12BB />} />
                <Route path="/claims" element={<Claims />} />
                <Route path='/allowanceclaim' element={<AllowanceClaimSystem />} />

                {/* <Route path="/investmentdec" element={<InvestmentDeclarationForm/>}/> */}
                <Route path="/investmentdec" element={<TaxFormWithTabs />} />
                <Route path="/lossproperty" element={<PropertyLossForm />} />
                <Route path="/investmentproof" element={<InvestmentProofSubmission />} />
              </Route>
              <Route element={<ProtectedRoute allowedRoles={["project-manager"]} />}>
              {/* <Route path="/project/:projectId/skill-matrix" element={<SkillMatrixPage />} /> */}
                <Route path="/viewclaims" element={<ViewClaims />} />
                <Route path='/perreport' element={<PerformanceReportDashboard />} />
              </Route>
              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager", "hiring-manager"]} />}>
                <Route path="/job-posting" element={<JobPosting />} />
                <Route path="/job-posting/:id" element={<JobPosting />} />
                <Route path="/candidates" element={<Tracking />} />
                <Route path="/interview-scheduling" element={<Interview />} />
                <Route path="/statusupdate" element={<InterviewStatusUpdate />} />
                <Route path="/status" element={<StatusPage />} />
                <Route path="/offerapproval" element={<OfferApproval />} />
              </Route>

              <Route element={<ProtectedRoute allowedRoles={["hr", "hr-manager"]} />}>
                <Route path="/gap-analysis" element={<GapAnalysis />} />
                <Route path="/offer" element={<OfferForm />} />
                <Route path="/onboarding" element={<OnboardingForm />} />
                <Route path="/OnboardingList" element={<OnboardingList />} />
                <Route path="/details" element={<HRTrainingDetail />} />
                <Route path="/test" element={<HRTestManagement />} />
                <Route path='/leavepolicies' element={<LeavePolicyManagement />} />
                <Route path="/alldetails" element={<HREmployeeFormWithTabs />} />
              </Route>


              <Route element={<ProtectedRoute allowedRoles={["employee","project-manager", "product-manager", "product-owner", "cpo","principal-project-manager"]} />}>
              <Route path='/project/:projectId/create-task' element={<CreateIssuePage />} />
                <Route path='/project/:projectId/CR' element={<ChangeRequirementsPage />} />
                <Route path='/project/:projectId/calendar' element={<ProjectCalendar />} />
                <Route path="/project/:projectId/backlog" element={<Backlogpage />} />
                <Route path="/project/:projectId/roadmap" element={<RoadmapPage sidebarOpen={sidebaropen}/>} />
                {/* <Route path='/project/:projectId/calendar' element={<ProjectCalendar /> } /> */}
                <Route path='/sprintcreate' element={<CreateSprint />} />
                <Route path="/project/:projectId/db-emp" element={<ProfessionalProjectDashboardEmp />} />
                <Route path='/project/:projectId/backlog/sprint/active' element={<ActiveSprints />} />
                <Route path='/project/:projectId/backlog/sprint/completed' element={<CompletedSprintBoard />} />
</Route>



              <Route element={<ProtectedRoute allowedRoles={["project-manager", "product-manager", "product-owner", "cpo","principal-project-manager"]} />}>
               <Route
                  path="/dash"
                  element={
                    <Dashboard

                    />
                  }
                />
                                <Route path="/create-project" element={<CreateProject />} />
                <Route path="/project-migration" element={<ProjectMigrationPage />} />
                <Route path='/pro' element={<AllProjects />} />

                <Route path="/active-projects" element={<ActiveProjects />} />
                <Route path="/npi-intake" element={<NpiIntakeDashboard />} />
                <Route path="/cpo-ppm-dashboard" element={<CpoPpmDashboard />} />
                <Route path="/portfolio-health" element={<CpoMultiProjectDashboard />} />
                <Route path="/resource-planning-dashboard" element={<ResourcePlanningDashboard />} />
                <Route path="/pm-cost-center-dashboard" element={<PMCostCenterDashboard />} />
 
              <Route path='/generate-quotation' element={<QuotationDashboard/>}/>
              <Route path="/quotation-preview/:id" element={<QuotationPreview/>} />

              <Route path='/quotation-from-template' element={<LiveQuotationFromTemplate/>}/>
              <Route path ='/frdtrd' element={<UploadFrd/>}/>
                              <Route path='/proupdates' element={<ProjectManagementSystem />} />

                              <Route path='/project/:projectId/tasks' element={<AllTasksPage />} />
                <Route path="/project/:projectId/db" element={<ProjectDashboard />} />

                <Route path="/assignteam" element={<AssignTeam />} />
                <Route path="/createteam" element={<TeamManagementApp />} />
                <Route path="/manageteam" element={<ManageTeam />} />
                <Route path="/resource-capacity" element={<ResourceCapacity />} />
                <Route path="/resource-planning-dashboard" element={<ResourcePlanningDashboard />} />
               <Route path='/project/:projectId/create-task' element={<CreateIssuePage />} />
                 {/* <Route path='/project/:projectId/CR' element={<ChangeRequirementsPage />} />
                <Route path='/project/:projectId/tasks' element={<AllTasksPage />} />
                <Route path='/project/:projectId/calendar' element={<ProjectCalendar />} />
                <Route path="/project/:projectId/backlog" element={<Backlogpage />} />
                <Route path="/project/:projectId/roadmap" element={<RoadmapPage sidebarOpen={sidebaropen}/>} /> */}
                {/* <Route path='/project/:projectId/calendar' element={<ProjectCalendar /> } /> */}
                {/* <Route path='/sprintcreate' element={<CreateSprint />} />
                <Route path="/project/:projectId/db" element={<ProjectDashboard />} />
                <Route path='/project/:projectId/backlog/sprint/active' element={<ActiveSprints />} />
                <Route path='/project/:projectId/backlog/sprint/completed' element={<CompletedSprintBoard />} /> */}
                <Route path='/createboard' element={<BasicBoard />} />
                <Route path='/viewproject' element={<ProjectDetailsDialog />} />
                <Route path="/reports" element={<PMReportDashboard />} />
             

              </Route>


            </Routes>
          </Box>
        </Box>
        <FloatingSupportWidget />
      </ThemeProvider>
    </Box>
  );
};

export default App;
